import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { forEach } from 'lodash';

import Annotation from '.';

class MobileContainer extends PureComponent {
  static displayName = 'MobileContainer';

  static propTypes = {
    annotationData: PropTypes.object,
    parentComponent: PropTypes.object,
    children: PropTypes.object.isRequired,
    isImpersonating: PropTypes.bool,
  };

  static defaultProps = {
    annotationData: null,
    parentComponent: null,
    isImpersonating: false,
  };

  componentDidMount() {
    if (!this._annotationTool) {
      const {
        learnosityData: { app },
        onShowModal,
        annotationData,
        isImpersonating,
      } = this.props;

      const containerNode = this.getDOMContainer('lrn-annotation-container');
      const content = (
        <Annotation
          app={app}
          showModal={onShowModal}
          annotationData={annotationData}
          isImpersonating={isImpersonating}
        />
      );
      const that = this;
      ReactDOM.render(content, containerNode, function () {
        that._annotationTool = this;
        if (that.props.parentComponent) {
          that.props.parentComponent.onTabChange = (visibleTab) =>
            this.setState({ visibleTab });
        }
      });
    }
  }

  componentWillUnmount() {
    const element = document.querySelector('.lrn-annotation-container');
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
      element.parentElement.removeChild(element);
    }
  }

  getDOMContainer = (className) => {
    const { fullScreen } = this.props;
    const mainContainer = fullScreen
      ? document.querySelector('body')
      : document.querySelector('.PlayerModeContainer--content');
    const containerNode = document.createElement('div');
    containerNode.className = `lrn-custom-container ${className}`;

    mainContainer.appendChild(containerNode);
    return containerNode;
  };

  /**
   * Control visibility of the annotation tool
   * */
  toggleAnnotations = (value) => {
    if (this._annotationTool) {
      this._annotationTool.setVisibility(value);
      const action = value ? 'add' : 'remove';
      const lrnQuestions = document.querySelectorAll('.lrn_question');
      forEach(lrnQuestions, (question) =>
        question.classList[action]('annotation--enabled'),
      );
    }
  };

  render() {
    const { children, ...otherProps } = this.props;
    const props = { ...otherProps, toggleAnnotations: this.toggleAnnotations };
    return React.cloneElement(children, props);
  }
}

export default MobileContainer;
